import { createStatusCellRenderer } from '@fortem-monorepo/react-ag'

export const FeedsStatusCellRenderer = createStatusCellRenderer({
  success: { label: 'Present', values: [true] },
  error: { label: 'Missing', values: [false, null, undefined] },
})
